import React from "react";
import {
  categories,
  popularSearches,
  cities
} from "../../data/homeDiscoveryData";

const HomeDiscoverySection = () => {
  return (
    <section className="home-discovery">
      <div className="container">

        <h2 className="section-title">
          Discover Popular Business Categories Across India
        </h2>

        <p className="section-description">
          BixxmarkIndia helps you explore trusted local businesses and essential
          services across major Indian cities — all in one place.
        </p>

        {/* Categories */}
        <div className="discovery-block">
          <h3 className="block-title">Popular Categories</h3>
          <ul className="link-list">
            {categories.map((item, index) => (
              <li key={index}>
                <a href={`/category/${item.toLowerCase().replace(/ & /g, "-").replace(/\s+/g, "-")}`}>
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Popular Searches */}
        <div className="discovery-block">
          <h3 className="block-title">Popular Searches on BixxmarkIndia</h3>
          <ul className="link-list">
            {popularSearches.map((item, index) => (
              <li key={index}>
                <a href="#">
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Cities */}
        <div className="discovery-block">
          <h3 className="block-title">Serving Businesses Across Major Indian Cities</h3>
          <ul className="link-list city-list">
            {cities.map((city, index) => (
              <li key={index}>
                <a href={`/city/${city.toLowerCase()}`}>
                  {city}
                </a>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
};

export default HomeDiscoverySection;